import styled from 'styled-components'
import { Row, Col } from '@gympass/yoga'
import getBreakpoint from '@client/utils/breakpoints'
import tokens from '@gympass/yoga-tokens'

export const Form = styled.form`
  & .MuiFormHelperText-root {
    color: #f46152;
  }

  ${Row}:first-of-type {
    ${Col}:first-of-type {
      .MuiFormControl-root:first-of-type {
        margin-top: 0px;

        @media (min-width: ${getBreakpoint('xl')}px) {
          margin-top: 24px;
        }
      }
    }
  }

  & .MuiFormControl-root {
    margin-top: 16px;

    @media (min-width: ${getBreakpoint('xl')}px) {
      margin-top: 24px;
    }
  }

  & .dynamic-checkbox-wrapper {
    display: flex;
    align-items: flex-start;
    margin-top: -8px;
    margin-bottom: 24px;

    .MuiCheckbox-root {
      margin-top: -28px;
    }

    label {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 17px;
      color: #535461;
      margin-top: 15px;
      margin-left: -12px;
      flex: 1;

      a {
        font-weight: 500;
        color: ${tokens.colors.vibin};
      }
    }

    @media (min-width: ${getBreakpoint('xl')}px) {
      > label {
        margin-top: 24px;
      }
    }
  }

  @media (min-width: ${getBreakpoint('xl')}px) {
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }
`

export const CheckboxWrapper = styled.section`
  display: flex;
  align-items: flex-start;
  margin-top: -8px;
  margin-bottom: 24px;

  .MuiCheckbox-root {
    margin-top: -28px;
  }

  label {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    color: #535461;
    margin-top: 15px;
    margin-left: -12px;
    flex: 1;

    a {
      font-weight: 500;
      color: ${tokens.colors.vibin};
    }
  }

  @media (min-width: ${getBreakpoint('xl')}px) {
    > label {
      margin-top: 24px;
    }
  }
`

export const Fieldset = styled.fieldset`
  margin: 56px 0 0 0;
  padding: 0;
  border: 0;

  &:first-of-type {
    margin-top: 50px;
  }

  > legend {
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    margin-bottom: 24px;

    @media (min-width: ${getBreakpoint('xl')}px) {
      margin-top: 32px;
    }
  }

  &:nth-of-type(4) {
    ${CheckboxWrapper} {
      margin-bottom: 8px;
    }
  }
`

export const Divider = styled.hr`
  margin-top: 56px;
  margin-bottom: 56px;
  background: #dbdbe8;
  height: 1px;
  border: none;
`

export const FormTitle = styled.h4`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  margin: 0 0 16px;
`

export const ConfirmationSubtitle = styled.h5`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  margin: 0 0 40px;
`

export const ButtonWrapper = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  margin-bottom: 64px;

  button:first-of-type {
    margin-bottom: 16px;
  }

  @media (min-width: ${getBreakpoint('xl')}px) {
    flex-direction: row-reverse;
    justify-content: space-between;
  }
`
